import SaveButton from "@/components/SaveButton";
import { memo } from "react";

/**
 * Keep this component for future use - delete button will be restored
 * once backend supports rate deletion (currently throws error on delete endpoint)
 */
interface ProjectRateEditorFooterProps {
  onDelete: () => void;
  isPending: boolean;
}

const ProjectRateEditorFooter = ({
  onDelete,
  isPending,
}: ProjectRateEditorFooterProps) => {
  return <SaveButton />;
};

export default memo(ProjectRateEditorFooter);
